import React, { useEffect, useCallback } from 'react';
import { Row, Col, Button, Form, TimePicker } from 'antd';
import moment from 'moment';

const TimeType = ({
  question,
  selectedAnswer,
  buttonsState,
  onSubmitAnswer,
  selectedOption,
  setSelectedOption,
}) => {
  const [form] = Form.useForm();

  const getInitialMoment = (value) => {
    if (!value || value.trim() === '') return null;
    return moment(value, 'HH:mm', true).isValid() ? moment(value, 'HH:mm') : null;
  };

  const setFieldValue = useCallback(() => {
    const initialMoment = getInitialMoment(selectedAnswer);
    form.setFieldsValue({ time: initialMoment });
    setSelectedOption(initialMoment ? initialMoment.format('HH:mm') : '');
  }, [selectedAnswer, form, setSelectedOption]);

  const handleTimeChange = (time) => {
    const formattedTime = time ? time.format('HH:mm') : '';
    setSelectedOption(formattedTime);
    form.setFieldsValue({ time });
  };

  const onFinish = (type) => {
    const timeValue = form.getFieldValue('time');
    const answerToSave = timeValue ? timeValue.format('HH:mm') : '';
    onSubmitAnswer(type, answerToSave);
    form.resetFields();
  };

  const isDisabled = () => {
    return buttonsState.isCurrentLastQuestion
      ? !selectedOption
      : buttonsState.lastQuestion && buttonsState.questionsUnanswered;
  };

  useEffect(() => {
    form.resetFields();
    setFieldValue();
  }, [selectedAnswer]);

  return (
    <Row justify="center">
      <Form
        form={form}
        style={{ width: '100%' }}
      >
        <Col md={24} className="options-wrapper p-40 mt-40 mb-80">
          <Row justify="center">
            <Col md={24}>
              <h2
                className="text-center mt-10 mb-50"
                dangerouslySetInnerHTML={{ __html: question.title && question.title }}
              />
            </Col>
            <Col md={10}>
              <Form.Item name="time" className="mb-0">
                <TimePicker
                  style={{ width: '100%', fontSize: '22px' }}
                  size="large"
                  format="HH:mm"
                  placeholder={question.title && question.title}
                  onChange={handleTimeChange}
                  value={getInitialMoment(selectedOption)}
                  minuteStep={1}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col md={24} className="mb-40">
          <Row>
            <Col md={5}>
              <Button
                className={'secondary-button'}
                size="large"
                onClick={() => onFinish('previus')}
                block
              >
                Anterior
              </Button>
            </Col>
            <Col md={buttonsState.isCurrentLastQuestion ? 12 : 14}></Col>
            <Col md={buttonsState.isCurrentLastQuestion ? 7 : 5} justify="end">
              <Button
                disabled={isDisabled()}
                className={isDisabled() ? 'button-disabled' : ''}
                type="primary"
                size="large"
                onClick={() => onFinish('foward')}
                block
              >
                {buttonsState.isCurrentLastQuestion ? 'Terminar cuestionario' : 'Siguiente'}
              </Button>
            </Col>
          </Row>
        </Col>
      </Form>
    </Row>
  );
};

export default TimeType;
